<div class="organization-modal modal-content" piqetAngularDraggable>
  <ng-container *ngrxLet="projectFacade.defalutMaterialProjectList$ as defalutMaterialProjectList">
    <div class="modal-header header-modal">
      <span class="bootstrap-dialog-title header-title">{{ modalLabel }} </span>
      <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
        <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
      </button>
    </div>
    <div class="modal-body">
      <form [formGroup]="myProjectForm" (keydown.enter)="$event.preventDefault()">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="form-group required" aria-required="true">
              <piqet-angular-common-input
                formControlName="projectName"
                [control]="myProjectForm.get('projectName')"
                label="Project name"
                placeholder="Project name"
                [maxLength]="100"
                [submitted]="submitted"
                [preventDot]="true"
                (customBlur)="getProjectname($any(myProjectForm.get('projectName')?.value))"
              >
              </piqet-angular-common-input>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="form-group required" aria-required="true">
              <piqet-angular-common-input
                formControlName="projectNameForReport"
                [control]="myProjectForm.get('projectNameForReport')"
                label="Project name used in report"
                placeholder="Project name used in report"
                [maxLength]="300"
                [preventDot]="true"
                [submitted]="submitted"
              >
              </piqet-angular-common-input>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
            <div class="form-group required">
              <label class="sub-header-drpdown pb-2">Share</label>
              <ng-select
                [clearable]="true"
                [clearOnBackspace]="false"
                #share
                [items]="shareItems"
                bindLabel="name"
                [searchable]="false"
                formControlName="share"
                [searchFn]="commonInputSearch"
                placeholder="Select share *"
                (change)="selectTeam($event)"
              >
                <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                  <div
                    [ngOptionHighlight]="search"
                    title="{{ item?.name }}"
                    [class.disabled]="item?.disabled"
                    class="option-content"
                  >
                    {{ item.name }}
                  </div>
                </ng-template>
              </ng-select>
              <div
                *ngIf="
                  (myProjectForm.controls['share']?.touched &&
                    myProjectForm.controls['share']?.invalid) ||
                  ((submitted || myProjectForm.controls['share'].touched) &&
                    !myProjectForm.controls['share'].value?.name)
                "
                class="input-error"
              >
                Share is required
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
            <div class="form-group required">
              <label class="sub-header-drpdown pb-2">Status</label>
              <ng-select
                [clearable]="true"
                [clearOnBackspace]="false"
                #status
                [items]="projectStatusList"
                [searchable]="false"
                bindLabel="name"
                bindValue="id"
                formControlName="status"
                [searchFn]="commonInputSearch"
                [readonly]="true"
                placeholder="Status"
              >
                <ng-template ng-header-tmp>
                  <div class="has-feedback">
                    <input
                      placeholder="Search..."
                      type="text"
                      class="form-control search-input"
                      id="inputValidation"
                      (input)="status.filter($any($event.target).value)"
                    />
                    <span class="form-control-feedback">
                      <i class="fa fa-search icon"></i>
                    </span>
                  </div>
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                  <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
                </ng-template>
              </ng-select>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="isHideDropDown">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="form-group required">
              <label
                *ngIf="myProjectForm.get('organizationName')?.value"
                class="sub-header-drpdown pb-2"
                >Organization</label
              >
              <ng-select
                [clearable]="true"
                [clearOnBackspace]="false"
                [items]="organizationlist"
                [searchable]="false"
                bindLabel="name"
                #organization
                formControlName="organizationName"
                [searchFn]="commonInputSearch"
                placeholder="Organization"
                [(ngModel)]="setOrganizationValue"
                (change)="selectValue($event)"
              >
                <ng-template ng-header-tmp>
                  <div class="has-feedback">
                    <input
                      placeholder="Search..."
                      type="text"
                      class="form-control search-input"
                      id="inputValidation"
                      (input)="organization.filter($any($event.target).value)"
                    />
                    <span class="form-control-feedback">
                      <i class="fa fa-search icon"></i>
                    </span>
                  </div>
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                  <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
                </ng-template>
              </ng-select>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="isShowTeamList">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="form-group required">
              <label *ngIf="myProjectForm.get('team')?.value" class="sub-header-drpdown pb-2"
                >Selected team</label
              >
              <ng-select
                [clearable]="true"
                [clearOnBackspace]="false"
                #team
                [items]="teamList"
                bindLabel="name"
                [searchable]="false"
                formControlName="team"
                [searchFn]="commonInputSearch"
                placeholder="Select team *"
              >
                <ng-template ng-header-tmp>
                  <div class="has-feedback">
                    <input
                      placeholder="Search..."
                      type="text"
                      class="form-control search-input"
                      id="inputValidation"
                      (input)="team.filter($any($event.target).value)"
                    />
                    <span class="form-control-feedback">
                      <i class="fa fa-search icon"></i>
                    </span>
                  </div>
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                  <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
                </ng-template>
              </ng-select>
              <div
                *ngIf="
                  (myProjectForm.controls['team']?.touched &&
                    myProjectForm.controls['team']?.invalid) ||
                  (submitted && !myProjectForm.controls['team'].value?.name)
                "
                class="input-error"
              >
                Team is required
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <label class="countryLable">{{ projectsPlaceholder.PROCESS_COUNTRY_LABEL }}</label>
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="form-group countryDropDown">
              <ng-select
                [clearable]="false"
                #country
                [items]="regionItems"
                [searchable]="false"
                bindLabel="name"
                formControlName="country"
                [searchFn]="commonInputSearchForCountry"
                (change)="defalutCountry($event)"
                [ngClass]="
                  myProjectForm.controls['country'].value?.length > 11 ? 'multi-select' : ''
                "
                [multiple]="true"
                [placeholder]="projectsPlaceholder.PROCESS_COUNTRY"
              >
                <ng-template ng-header-tmp>
                  <div class="has-feedback">
                    <input
                      placeholder="Search..."
                      type="text"
                      class="form-control accordion-search search-input"
                      id="inputValidation"
                      (input)="country.filter($any($event.target).value)"
                    />
                    <span class="form-control-feedback">
                      <i class="fa fa-search icon"></i>
                    </span>
                  </div>
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                  <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
                </ng-template>
              </ng-select>
            </div>
          </div>
        </div>
        <div class="row">
          <label class="countryLable">{{ projectsPlaceholder.DEFAULT_COUNTRY_LABEL }}</label>
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="form-group required">
              <ng-select
                [clearable]="true"
                [clearOnBackspace]="false"
                #defaultCountry
                [items]="selectCountry || defaultRegionItems"
                [searchable]="false"
                bindLabel="name"
                formControlName="defaultCountry"
                [searchFn]="commonInputSearchForCountry"
                [placeholder]="projectsPlaceholder.DEFAULT_COUNTRY"
              >
                <ng-template ng-header-tmp>
                  <div class="has-feedback">
                    <input
                      placeholder="Search..."
                      type="text"
                      class="form-control accordion-search search-input"
                      id="inputValidation"
                      (input)="defaultCountry.filter($any($event.target).value)"
                    />
                    <span class="form-control-feedback">
                      <i class="fa fa-search icon"></i>
                    </span>
                  </div>
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                  <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
                </ng-template>
              </ng-select>
              <div
                *ngIf="
                  (myProjectForm.controls['defaultCountry']?.touched &&
                    myProjectForm.controls['defaultCountry']?.invalid) ||
                  (submitted && !myProjectForm.controls['defaultCountry'].value?.description)
                "
                class="input-error"
              >
                Country is required
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="form-group checkbox-text checkBoxAlienMent">
              <input
                class="chkOverview"
                type="checkbox"
                [(ngModel)]="selectCheckBox"
                [ngModelOptions]="{ standalone: true }"
                (change)="showMoreFields()"
              />
              <span class="sub-header-drpdown pt-1">Switch on cost</span>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="!isShowCusurrencyField">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="form-group">
              <label *ngIf="myProjectForm.get('currency')?.value" class="sub-header-drpdown pb-2"
                >Currency</label
              >
              <ng-select
                [clearable]="false"
                [clearOnBackspace]="false"
                #currency
                [items]="currencyItems"
                [searchable]="false"
                bindLabel="name"
                formControlName="currency"
                [searchFn]="commonInputSearch"
                placeholder="Currency"
              >
                <ng-template ng-header-tmp>
                  <div class="has-feedback">
                    <input
                      placeholder="Search..."
                      type="text"
                      class="form-control accordion-search search-input"
                      id="inputValidation"
                      (input)="currency.filter($any($event.target).value)"
                    />
                    <span class="form-control-feedback">
                      <i class="fa fa-search icon"></i>
                    </span>
                  </div>
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                  <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
                </ng-template>
              </ng-select>
            </div>
          </div>
        </div>
        <div class="row mb-4">
          <div class="col-sm-7">
            <piqet-angular-file-upload
              type="image"
              [customConfig]="{
                placeholderText: 'Project image',
                selectButtonText: 'Select file',
                showPreview: false
              }"
              [customClass]="'col-sm-12'"
              [isImageValid]="isImageValid"
              (fileSelected)="onFileSelected($event)"
              (removeConfirmation)="onFileRemove()"
            ></piqet-angular-file-upload>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="form-group textarea">
              <div class="services-form">
                <textarea
                  formControlName="description"
                  cols="20"
                  id="Description"
                  name="Description"
                  rows="2"
                  placeholder="Description"
                  class="descriptionHEight"
                ></textarea>
                <label>Goal and scope</label>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-end">
            <span
              ><a (click)="showDeafultSettings()" class="defaultSettings">
                Change default recycling credits settings</a
              ></span
            >
            <span
              class="setLinkIconPosition"
              placement="auto"
              tooltipClass="sku-tooltip"
              ngbTooltip="Adjust the A factor or select the PEF method that aims to reflect market realities."
            >
              <img src="./assets/icons/question-mark-icon.svg" width="16" height="16"
            /></span>
          </div>
        </div>
        <div *ngIf="isShowDefalutSettings">
          <div class="row">
            <div class="col-sm-6">
              <label class="defaultSettingsData fw-bolder">Recycling credits</label>
              <div class="form-group recycling-credit">
                <div class="project-spacing recycling-drp-pos">
                  <ng-select
                    [clearable]="true"
                    [clearOnBackspace]="false"
                    #recyclingCred
                    (change)="updateRange($event, defalutMaterialProjectList)"
                    [items]="myProjectData?.recycledCreditsList"
                    [searchable]="false"
                    bindLabel="name"
                    (clear)="onClear(defalutMaterialProjectList)"
                    [searchFn]="commonInputSearch"
                    placeholder="Recycling credits"
                    formControlName="recycledCredit"
                  >
                    <ng-template ng-header-tmp>
                      <div class="has-feedback">
                        <input
                          type="text"
                          class="form-control accordion-search search-input"
                          id="inputValidation"
                          placeholder="Search..."
                          (input)="recyclingCred.filter($any($event.target).value)"
                        />
                        <span class="form-control-feedback">
                          <i class="fa fa-search icon"></i>
                        </span>
                      </div>
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                      <div [ngOptionHighlight]="search" title="{{ item?.name }}">
                        {{ item.name }}
                      </div>
                    </ng-template>
                  </ng-select>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="myProjectForm.controls['recycledCredit'].value?.id == 3">
            <div class="row">
              <div class="col-sm-6">
                <div class="form-group">
                  <label class="defaultSettingsData">All credits for recycled content</label>
                </div>
              </div>
              <div class="col-sm-6 text-end">
                <div class="form-group">
                  <label class="defaultSettingsData"
                    >All credits for recycling at End-of-life</label
                  >
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 form-group">
                <div
                  aria-required="true"
                  [ngClass]="{ 'disabled-project': disableSlider ? true : false }"
                >
                  <ngx-slider
                    [options]="options"
                    (userChangeEnd)="changeRuralValue($event)"
                    formControlName="recycleContent"
                  ></ngx-slider>
                </div>
              </div>
              <div
                class="col-sm-12 d-flex justify-content-end pe-2"
                *ngIf="myProjectForm.controls['recycledCredit'].value?.id == 3"
              >
                <div class="form-group checkbox-text checkBoxAlienMent">
                  <input
                    class="chkOverview"
                    type="checkbox"
                    [ngModelOptions]="{ standalone: true }"
                    (change)="
                      applyToAllSlider(
                        defalutMaterialProjectList,
                        applyToAll,
                        myProjectForm.controls['recycledCredit'].value
                      )
                    "
                    [(ngModel)]="applyToAll"
                  />
                  <span class="defaultSettingsData"> Apply to all</span>
                </div>
              </div>
            </div>
            <div class="row">
              <div>
                <div class="input-error">{{ errorNotification }}</div>
                <div id="divmanufactureofmaterialList" class="grid-div">
                  <input
                    data-val="true"
                    data-val-number="The field CustomMaterialId must be a number."
                    data-val-required="The CustomMaterialId field is required."
                    type="hidden"
                    value="0"
                  />
                  <piqet-angular-portlet
                    [columnDefs]="processColumnDef"
                    [frameworkComponents]="frameworkComponents"
                    [gridData]="defalutMaterialProjectList"
                    [hidePagination]="true"
                    [hideSearch]="true"
                    [isInlineGrid]="true"
                    (editDataEvent)="checkValidation(defalutMaterialProjectList)"
                    [class]="'overflowCheck'"
                    (inlineDataEditEvent)="inlineDataEditEvent($event)"
                    [error]="errorNotification"
                    [recycleCreditId]="myProjectForm.controls['recycledCredit'].value?.id"
                    [sliderValue]="myProjectForm.controls['recycleContent'].value"
                    [disableButton]="disableSubmit"
                    [headerBtn]="headerBtn"
                    [headerBtnName]="headerBtnName"
                  >
                  </piqet-angular-portlet>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="setButtonAndError text-margin">
          <div class="modal-footer">
            <button type="button" class="btn btn-light cancelBtn" (click)="onClose()">
              Cancel
            </button>
            <button
              type="button"
              class="modelBtn purpleBtnHoverEffect"
              [disabled]="disableSubmit"
              (click)="onSave(defalutMaterialProjectList)"
            >
              Save
            </button>
          </div>
          <div
            class="redErrorTag"
            *ngIf="
              (submitted &&
                (myProjectForm.controls['projectName']?.invalid ||
                  myProjectForm.controls['projectNameForReport']?.invalid ||
                  myProjectForm.controls['share']?.invalid ||
                  myProjectForm.controls['status']?.invalid ||
                  myProjectForm.controls['defaultCountry']?.invalid)) ||
              myProjectForm.controls['team']?.invalid
            "
          >
            <div class="bigScreenErrContain">
              <div>
                <span> <img src="./assets/icons/swalDeletion.svg" width="53" height="48" /></span>
              </div>
              <div>
                <div class="mb-3">
                  <span>To proceed please complete the following fields : </span>
                </div>
                <div
                  class="topBottomCss"
                  *ngIf="
                    (submitted || myProjectForm.controls['projectName']?.touched) &&
                    myProjectForm.controls['projectName']?.invalid
                  "
                >
                  <div
                    *ngIf="
                      (myProjectForm.controls['projectName']?.touched &&
                        myProjectForm.controls['projectName']?.invalid) ||
                      myProjectForm.controls['projectName'].hasError('whitespace')
                    "
                  >
                    Project name
                  </div>
                </div>
                <div
                  class="topBottomCss"
                  *ngIf="
                    (submitted || myProjectForm.controls['projectNameForReport']?.touched) &&
                    myProjectForm.controls['projectNameForReport']?.invalid
                  "
                >
                  <div
                    *ngIf="
                      (myProjectForm.controls['projectNameForReport']?.touched &&
                        myProjectForm.controls['projectNameForReport']?.invalid) ||
                      myProjectForm.controls['projectNameForReport'].hasError('whitespace')
                    "
                  >
                    Project name used in report
                  </div>
                </div>

                <div class="topBottomCss">
                  <div
                    *ngIf="
                      (myProjectForm.controls['share']?.touched &&
                        myProjectForm.controls['share']?.invalid) ||
                      ((submitted || myProjectForm.controls['share'].touched) &&
                        !myProjectForm.controls['share'].value?.name)
                    "
                  >
                    Share
                  </div>
                </div>

                <div
                  class="topBottomCss"
                  *ngIf="isShowTeamList && !this.myProjectForm.controls['team'].value"
                >
                  <div
                    *ngIf="
                      (myProjectForm.controls['team']?.touched &&
                        myProjectForm.controls['team']?.invalid) ||
                      (submitted && !myProjectForm.controls['team'].value?.name)
                    "
                  >
                    Team
                  </div>
                </div>

                <div class="topBottomCss">
                  <div
                    *ngIf="
                      (myProjectForm.controls['defaultCountry']?.touched &&
                        myProjectForm.controls['defaultCountry']?.invalid) ||
                      (submitted && !myProjectForm.controls['defaultCountry'].value?.description)
                    "
                  >
                    Country
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </ng-container>
</div>
